(function () {
  var PANEL_IDS = ['orders', 'customers', 'inventory', 'refunds', 'tax', 'shipping'];

  function show(id, el) {
    document.querySelectorAll('.data-map-panel').forEach(function (p) { p.classList.remove('active'); });
    document.querySelectorAll('.data-map-tab').forEach(function (t) { t.classList.remove('active'); });
    var panel = document.getElementById(id);
    if (panel) panel.classList.add('active');
    if (el) el.classList.add('active');
  }

  function init() {
    var tabs = document.querySelectorAll('.data-map-tab');
    if (!tabs.length) return;
    tabs.forEach(function (tab, i) {
      var id = PANEL_IDS[i];
      if (!id) return;
      tab.addEventListener('click', function () { show(id, tab); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
